import React from 'react';
import NavMenu from './NavMenu';
import useDebugInformation from '../../hooks/useDebugInformation';
import AgentsDialog from "./AgentsDialog"
import { Box, Container, CssBaseline } from '@mui/material';
import useNetwork from '../../hooks/useNetworkInfo';
import NetworkDownSpinner from './NetworkDownSpinner/index';
import CacheHydration from './CacheHydration';
import { useAppSelector } from "@store/hooks";
import { Routes, Route } from 'react-router-dom';
import BookingForm from './BookingForm';
import GoHome from './GoHome';
import Switchboard from './Switchboard';
import { ApiAuthorizationRoutes } from '../Authorization/ApiAuthorizationRoutes';
import Home from './Home';
import SideDrawer from './SideDrawer';

const name = "Layout";

const Layout: React.FC = () => {
  const networkInfo = useNetwork();
  const cacheLoading = useAppSelector(({ state }) => state.CacheLoading);
  const authRoutes = React.useCallback(() => ApiAuthorizationRoutes(), [])

  useDebugInformation("Layout", { authRoutes })

  return (
    <Box component="div">
      <NavMenu />
      <CssBaseline />
      <AgentsDialog />
      <NetworkDownSpinner open={!networkInfo.online} />
      {cacheLoading && <CacheHydration open={cacheLoading} />}
      <Container maxWidth="lg" >
        {/* TODO: Implement as feature */}
        <SideDrawer />
        <Routes>
          <Route path="/" element={<Home parent="[App]" />} />
          <Route path="booking-form" element={<BookingForm parent="[App]" />} />
          <Route path="switchboard" element={<Switchboard parent="[App]" />} />
          <Route path="go-home" element={<GoHome parent="[App]" />} />
          {authRoutes()}
        </Routes>
      </Container>
    </Box>
  )
};

Layout.displayName = name;

export default React.memo(Layout)